import {useQuery} from '@apollo/client';
import {CorrespondenceNeedOptions} from '../../schema-types/CorrespondenceNeedOptions';
import {GET_CORRESPONDENCE_NEED_OPTIONS} from './correspondenceNeedQueries';

/**
 * The correspondence needs OneView may set (Audio, Braille, Large Font) and
 * whether the feature is live on this environment (DBO-80). It is gated to the
 * Hubwise instance because the Curo task it raises is a Hubwise workaround.
 */
export const useCorrespondenceNeedOptions = () => {
  const {data, loading, error} = useQuery<CorrespondenceNeedOptions>(
    GET_CORRESPONDENCE_NEED_OPTIONS
  );
  if (error) {
    // The UI treats a failed lookup as "feature unavailable", so make the
    // cause visible rather than hiding the column silently.
    console.error('correspondenceNeedOptions query failed', error);
  }
  return {
    loading,
    isEnabled: data?.correspondenceNeedOptions.isEnabled ?? false,
    options: data?.correspondenceNeedOptions.options ?? [],
  };
};
